module.exports = __webpack_public_path__ + "img/beginners-series_homepage-tile_poster.cf226c1.jpg";